export interface IMetadataEntry {
	Attributes: { Key: string; Value: string }[];
	AuthorisationMode: 'Private' | 'Public';
	Category: string;
	Key: string;
	MetadataVersionId: string;
	Content: { ContentType: string; Data: string };
	Name: string;
	Timestamp: string;
	UserId: string;
}

export const MetadataCategories = {
	newsletter_templates: {
		title: 'Newsletter Templates',
		value: 'EDITOR_SAVED_TEMPLATES',
	},
	newsletter_custom_rows: {
		title: 'Newsletter Custom Rows',
		value: 'EDITOR_SAVED_CUSTOM_STRUCTURES',
	},
	landing_page_templates: {
		title: 'Landing Page Templates',
		value: 'DESIGNER_SAVED_TEMPLATES',
	},
	landing_page_custom_rows: {
		title: 'Landing Page Custom Rows',
		value: 'DESIGNER_SAVED_CUSTOM_STRUCTURES',
	},
	popup_templates: {
		title: 'Popup Form Templates',
		value: 'POPUP_SAVED_TEMPLATES',
	},
	popup_page_custom_rows: {
		title: 'Popup Form Custom Rows',
		value: 'POPUP_SAVED_CUSTOM_STRUCTURES',
	},
	inline_templates: {
		title: 'Inline Form Templates',
		value: 'INLINE_SAVED_TEMPLATES',
	},
	inline_custom_rows: {
		title: 'Inline Custom Rows',
		value: 'INLINE_SAVED_CUSTOM_STRUCTURES',
	},
	smart_bar_templates: {
		title: 'Smart Bar Form Templates',
		value: 'SMARTBAR_SAVED_TEMPLATES',
	},
	smart_bar_custom_rows: {
		title: 'Smart Bar Custom Rows',
		value: 'SMARTBAR_SAVED_CUSTOM_STRUCTURES',
	},
	scroll_box_templates: {
		title: 'Scroll Box Form Templates',
		value: 'SCROLLBOX_SAVED_TEMPLATES',
	},
	scroll_box_custom_rows: {
		title: 'Scroll Box Custom Rows',
		value: 'SCROLLBOX_SAVED_CUSTOM_STRUCTURES',
	},
	welcome_mat_templates: {
		title: 'Welcome Mat Form Templates',
		value: 'WELCOMEMAT_SAVED_TEMPLATES',
	},
	welcome_mat_custom_rows: {
		title: 'Welcome Mat Custom Rows',
		value: 'WELCOMEMAT_SAVED_CUSTOM_STRUCTURES',
	},
	dashboard_widgets: {
		title: 'Dashboard Widgets',
		value: 'DASHBOARD_WIDGETS',
	},
	dashboard_templates: {
		title: 'Dashboard Templates',
		value: 'DASHBOARD_TEMPLATES',
	},
	segmentation_templates: {
		title: 'Segmentation Templates',
		value: 'SEGMENT_CUSTOM_TEMPLATES',
	},
	rule_service_category: {
		title: 'Rule Service Category',
		value: 'RULE_SERVICE_CATEGORY',
	},
	members_plugins: {
		title: 'Members Plugins',
		value: 'members-plugins',
	},
	main_dashboards: {
		title: 'Main Dashboards',
		value: 'MAIN_DASHBOARDS',
	},
	integrations: {
		title: 'Integrations',
		value: 'integrations',
	},
	imagePickerKeys: {
		title: 'Image Picker Keys',
		value: 'IMAGE_PICKER_KEYS',
	},
	textEditor: {
		title: 'Text Editor',
		value: 'TEXT_EDITOR_DATA',
	},
};
